import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Truck } from "lucide-react";

const CARRIERS = [
  { id: "usps", label: "USPS" },
  { id: "ups", label: "UPS" },
  { id: "fedex", label: "FedEx" },
  { id: "other", label: "Other / hand-delivered" },
];

export default function ShipDialog({ open, order, onClose, onConfirm }) {
  const [carrier, setCarrier] = useState("usps");
  const [number, setNumber] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      await onConfirm({ carrier, tracking_number: number.trim() || undefined });
      setNumber("");
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="ship-dialog">
        <DialogHeader>
          <DialogTitle className="font-display font-black text-[#0C2E2B] flex items-center gap-2"><Truck className="w-5 h-5" /> Mark shipped{order?.ref_id ? ` · ${order.ref_id}` : ""}</DialogTitle>
          <DialogDescription>Paste the tracking number and we'll email the customer a tracking link right away.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <Label className="text-xs font-bold uppercase tracking-widest text-zinc-700">Carrier</Label>
            <div className="mt-1 grid grid-cols-2 gap-2">
              {CARRIERS.map((c) => (
                <button key={c.id} type="button" data-testid={`ship-carrier-${c.id}`} onClick={() => setCarrier(c.id)}
                  className={`h-10 rounded-md border-2 text-sm font-bold ${carrier === c.id ? "border-[#0C2E2B] bg-[#0C2E2B] text-white" : "border-zinc-200 bg-white text-zinc-700 hover:border-zinc-400"}`}>
                  {c.label}
                </button>
              ))}
            </div>
          </div>
          <div>
            <Label htmlFor="ship-tracking" className="text-xs font-bold uppercase tracking-widest text-zinc-700">Tracking number (optional)</Label>
            <Input id="ship-tracking" data-testid="ship-tracking-input" value={number} onChange={(e) => setNumber(e.target.value)} placeholder="e.g. 9400 1000 0000 0000 0000 00" className="mt-1 font-mono-data" />
          </div>
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" onClick={onClose} className="rounded-md font-bold" data-testid="ship-cancel-btn">Cancel</Button>
          <Button data-testid="ship-confirm-btn" onClick={submit} disabled={busy} className="rounded-md bg-blue-600 hover:bg-blue-700 text-white font-bold">{busy ? "Saving…" : "Mark shipped"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
